const persons = {
	title: "Kontakter",
	new_person: "Ny kontakt",
	edit_person: "Rediger kontakt: {name}",
	view_person: "Vis kontakt: {name}",
	person_title: "Kontakt detaljer",
	list_title: "Kontakter",
	list_subtitle: "Håndter kontakter",
	id: "ID",
	first_name: "Fornavn",
	last_name: "Etternavn",
	middle_name: "Mellomnavn",
	mobile: "Mobil",
	email: "Epost",
	comments: "Kommentarer",
	create_as_user: "Opprett som bruker",
};
export default persons;